import { createSlice, PayloadAction, Dispatch } from '@reduxjs/toolkit';
import { apiLogin } from 'src/api/auth';
import { UserState } from 'src/interface/user/user.interface';
import moment from 'moment';

import { LoginParams, Role } from '../../interface/user/login.interface';
import { useNavigate } from 'react-router-dom'; // 修改为 React Router 的 useNavigate

import store from 'src/stores/index';
import { Http } from "../../utils/http";
import { authServiceApp, dispsetServiceApp } from "../../utils/constants/serviceModule"; // 引入 Redux store

async function verifyToken(localState: UserState): Promise<boolean> {

  // 获取 localStorage 里的参数
  const api = localStorage.getItem('api');
  const chyjrtgnApp1 = localStorage.getItem('chyjrtgnApp1');
  const cachekeyApp1 = localStorage.getItem('cachekeyApp1');
  const platformsessionId = localStorage.getItem('platformsessionId');
  const uid = localStorage.getItem('uid');

  // 检查 Redux store 中的值与 localStorage 的值是否一致
  if (
    !localState.api ||
    !localState.chyjrtgnApp1 ||
    !localState.cachekeyApp1 ||
    !localState.platformsessionId ||
    !localState.uid
  ) {
    console.log('store user', localState);
    // 如果任意一个参数不存在，直接失败
    if (!api || !chyjrtgnApp1 || !cachekeyApp1 || !platformsessionId || !uid) {
      return false;
    } else {
      await store.dispatch(setLoged({
        api: api,
        platformsessionId: platformsessionId,
        chyjrtgnApp1: chyjrtgnApp1,
        cachekeyApp1: cachekeyApp1,
        uid: uid,
      }))
    }
  }
  return true; // 验证通过
}

const initialState: UserState = {
  logged: false,
  uid: localStorage.getItem('uid') || '',
  api: localStorage.getItem('api') || '',
  chyjrtgnApp1: localStorage.getItem('chyjrtgnApp1') || '',
  cachekeyApp1: localStorage.getItem('cachekeyApp1') || '',
  platformsessionId: localStorage.getItem('platformsessionId') || '',
  name: 'admin'
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setLoged(state, action: PayloadAction<Partial<UserState>>) {
      const { api, chyjrtgnApp1, cachekeyApp1, platformsessionId, uid } = action.payload;
      if (api) {
        localStorage.setItem('api', api);
      }
      if (chyjrtgnApp1) {
        localStorage.setItem('chyjrtgnApp1', chyjrtgnApp1);
      }
      if (cachekeyApp1) {
        localStorage.setItem('cachekeyApp1', cachekeyApp1);
      }
      if (platformsessionId) {
        localStorage.setItem('platformsessionId', platformsessionId);
      }
      if (uid) {
        localStorage.setItem('uid', uid);
      }
      Object.assign(state, action.payload);
    },
    setUsername(state, action: PayloadAction<Partial<UserState>>) {
      state.name = action.payload.name!;
    },

    verifyUserToken(state, action: PayloadAction<boolean>) {
      state.logged = action.payload; // 根据传入的验证结果更新状态
    }
  }
});

export const { setLoged, verifyUserToken, setUsername } = userSlice.actions;

export default userSlice.reducer;

export const loginAsync = (payload: LoginParams) => {
  return async (dispatch: Dispatch) => {
    const result = await apiLogin(payload);
    if (result?.success) {
      // 保存用户信息到状态和 localStorage
      dispatch(
        setLoged({
          logged: true,
          api: result.rsData.ssoMap['api'],
          chyjrtgnApp1: result.rsData.ssoMap['chyjrtgn-app1'],
          cachekeyApp1: result.rsData.ssoMap['cachekey-app1'],
          uid: result.rsData.ssoMap['uid'],
          platformsessionId: result.rsData.ssoMap.platformsessionId
        })
      );
    }
    return result;
  };
};

export async function apiGetLogoUrl(params?: any) {
  return Http.Post('/login/query-list/get-logo-url', params, authServiceApp);
}

export const logoutAsync = (navigate: ReturnType<typeof useNavigate>) => {
  return async (dispatch: Dispatch) => {
    clearAuthInfo();
    dispatch(
      setLoged({
        logged: false,
        api: '',
        chyjrtgnApp1: '',
        cachekeyApp1: '',
        platformsessionId: '',
        uid: '',
      })
    );
    navigate('/account/login', { replace: true }); // 通过传入的 navigate 实例导航
  };
};

const clearAuthInfo = () => {
  localStorage.removeItem('api');
  localStorage.removeItem('chyjrtgnApp1');
  localStorage.removeItem('cachekeyApp1');
  localStorage.removeItem('platformsessionId');
  localStorage.removeItem('uid');
};

export const verifyTokenSync = () => {
  return async (dispatch: Dispatch) => {
    const { user } = store.getState(); // 从 Redux store 中获取当前的 user 状态
    const result =await  verifyToken(user); // 调用验证函数
    await dispatch(verifyUserToken(result)); // 将验证结果传给 reducer
  };
};
